import React from 'react'
import PropTypes from 'prop-types'

const ChevronBottomIcon = ({ width = 17, height = 10, color = '#000' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.75 1.625l6.75 6.75 6.75-6.75"
        stroke={color}
        strokeWidth={1.57857}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

ChevronBottomIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

export default React.memo(ChevronBottomIcon)
